(function () {
    "use strict";

    angular.module("app").controller("SearchPhysicalInstallationsController", SearchPhysicalInstallationsController);
    SearchPhysicalInstallationsController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "physicalInstallation", "habilDate", ];
    function SearchPhysicalInstallationsController(controllerDecorator, infiniteScrollDataSourceFactory, physicalInstallation, habilDate) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });
        
        vm.GetStyle = getStyle;
        vm.DownloadExport = downloadExport;

        initialize();

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(physicalInstallation.Search, (v) => vm.isLoadingRequests = v);

            if (vm.PageAndSort.SortBy.length > 0) {
                vm.sortType = vm.PageAndSort.SortBy[0].Name;
                vm.sortReverse = vm.PageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "Identifier";
                vm.sortReverse = false;
            }

            vm.SetLoadingState(false);
        }
        
        function getStyle(installation) {
            if (installation.UsingOrganisation.ClearanceExpiration === null || installation.UsingOrganisation.HasExpiredClearance)
                return "overview-expired";

            if (!installation.ApprovedUntil)
                return "";

            const expiration = habilDate.GetDateOnly(installation.ApprovedUntil);
            const today = habilDate.GetDateOnly(new Date());

            if (expiration.valueOf() < today.valueOf())
                return "overview-expired";

            if (installation.UsingOrganisation.ClearanceExpiration === null || installation.UsingOrganisation.HasExpiredClearance)
                return "overview-expired";

            const oneYearFromNow = habilDate.GetDateOnly(new Date()).setFullYear(today.getFullYear() + 1);
            if (expiration.valueOf() < oneYearFromNow.valueOf())
                return "overview-expiring";

            return "overview-valid";
        }

        function downloadExport() {
            vm.SetLoadingState(true);

            const filter = vm.DataSource.GetFilter();
            physicalInstallation.DownloadExport(
                { Filter: filter },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();
